import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DxButtonModule, DxDataGridComponent, DxDataGridModule, DxDropDownButtonModule, DxSelectBoxModule, DxTextBoxModule, DxToolbarModule, NestedOptionHost } from 'devextreme-angular';
import { ActionIDs } from '../../../shared/enums/tables.enum';

@Component({
  standalone: true,
  selector: 'app-reusable-grid',
  templateUrl: './reusable-grid.component.html',
  styleUrl: './reusable-grid.component.scss',
  imports: [
    DxButtonModule,
    DxDataGridModule,
    DxDropDownButtonModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    DxToolbarModule,

    //StatusIndicatorModule,

    CommonModule,
  ],
  providers: [NestedOptionHost],

})
export class ReusableGridComponent implements OnChanges {
  public ActionIDs = ActionIDs;
  @ViewChild(DxDataGridComponent, { static: false }) grid!: DxDataGridComponent;
  @Input() dataSource: any[] = [];
  @Input() columns: any[] = [];
  @Input() pageSize: number = 15;
  @Input() Id!: number;
  @Output() rowClicked = new EventEmitter<any>();
  @Output() actionClicked = new EventEmitter<{ action: string, data: any }>();

  @Output() edit = new EventEmitter<number>();
  @Output() delete = new EventEmitter<number>();

  ngOnChanges(changes: SimpleChanges) {
    if (changes['dataSource']) {
      if(this.Id == ActionIDs.Stock)
      this.dataSource = changes['dataSource'].currentValue.filter((item) => !!item.status && !!item.merchant && !!item.expiryDate && !!item.visaReference);
    }
  };

  search(text: string) {
    console.log(this.grid.instance)
    this.grid.instance.searchByText(text);

  }

  editRow(rowIndex: number) {
    this.edit.emit(rowIndex);
  }

  deleteRow(rowIndex) {
    this.delete.emit(rowIndex);
  }

  onRowClick(event: any) {
    this.rowClicked.emit(event);
  }
}
